import { PAYMENT_PROVIDER } from "@APP/types";
import CONFIG from "./config.json";

interface AppConfig {
  PRODUCT_NAME: string;
  APP_ENV: string;
  VERSION: string;
  API: {
    ROOT_URL: string;
    REDIRECT_PATH_PAYMENT_COMPLETE: string;
    VERSION: string;
    CUSTODIANS_PROVIDER_PATH: string;
  };
  URLS: {
    APP_STORE_URL: string;
    PLAY_STORE_URL: string;
    TERMS_AND_CONDITIONS_URL: string;
    PAYMENT_PROVIDER: {
      TERMS_AND_CONDITIONS_URL: string;
      PRIVACY_POLICY_URL: string;
    };
    // LBG-hosted footer destinations, only present for the lloyds environment.
    LLOYDS?: {
      CHARGES_URL: string;
      COOKIE_POLICY_URL: string;
      COMMERCIAL_BANKING_URL: string;
      SECURITY_URL: string;
      LEGAL_URL: string;
      TERMS_AND_CONDITIONS_URL: string;
      PRIVACY_URL: string;
      BANKING_WITH_US_URL: string;
      ABOUT_US_URL: string;
      ABOUT_THIS_SITE_URL: string;
    };
    OCM: {
      ROOT_URL: string;
      LOGIN_URL: string;
      REGISTRATION_URL?: string;
    };
    MOBILE?: {
      LOGIN_URL: string;
    };
  };
  ASSOCIATION: {
    CO_OPERATIVE_BANK: boolean;
  };
  HOSTED_PAGES: {
    TERMS_AND_CONDITIONS: boolean;
    PRIVACY_NOTICE: boolean;
  };
  FEATURE?: {
    SQUARE: boolean;
    // Cookie consent banner is shown unless an environment explicitly opts out (e.g. lloyds).
    COOKIE_CONSENT?: boolean;
  };
  SERVICES: {
    SENTRY?: {
      ORG: string;
      PROJECT: string;
      DSN: string;
    };
    CLARITY?: {
      ID?: string;
    };
    SQUARE?: {
      WEB_SDK_CDN_URL: string;
      APP_ID: string;
      CURRENCY: string;
    };
  };
  PAYMENT_PROVIDER: PAYMENT_PROVIDER;
}

if (CONFIG.APP_ENV !== "production" || process.env.NODE_ENV !== "production") {
  console.info("App сonfiguration:", CONFIG);
} else {
  console.info(`v${CONFIG.VERSION}`);
}

export default CONFIG as AppConfig;
